import { render, staticRenderFns } from "./MtipobultoGrid.vue?vue&type=template&id=f9deb92a"
import script from "./MtipobultoGrid.vue?vue&type=script&lang=js"
export * from "./MtipobultoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports